import { render, staticRenderFns } from "./mediateCost.vue?vue&type=template&id=2026d903&scoped=true&"
import script from "./mediateCost.vue?vue&type=script&lang=tsx&"
export * from "./mediateCost.vue?vue&type=script&lang=tsx&"
import style0 from "./mediateCost.vue?vue&type=style&index=0&id=2026d903&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2026d903",
  null
  
)

export default component.exports